var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoBasic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M8 1c1.87 0 3.628.728 4.95 2.05A6.951 6.951 0 0 1 15 8c0 1.87-.727 3.627-2.05 4.95A6.954 6.954 0 0 1 8 15a6.958 6.958 0 0 1-4.95-2.05A6.956 6.956 0 0 1 1 8c0-1.87.728-3.628 2.05-4.95A6.958 6.958 0 0 1 8 1Zm0 1.2a5.763 5.763 0 0 0-4.1 1.699A5.76 5.76 0 0 0 2.199 8c0 1.549.605 3.006 1.7 4.101A5.763 5.763 0 0 0 8 13.8a5.76 5.76 0 0 0 4.1-1.699A5.762 5.762 0 0 0 13.8 8a5.762 5.762 0 0 0-1.698-4.101A5.76 5.76 0 0 0 8 2.2Zm-.427 4.924c.275 0 .533.107.727.301.19.19.3.454.3.725v2.134a.254.254 0 0 0 .253.253h.427a.6.6 0 1 1 0 1.2h-.427a1.46 1.46 0 0 1-1.028-.426 1.46 1.46 0 0 1-.425-1.027v-1.96h-.253a.6.6 0 1 1 0-1.2h.426Zm.112-2.69c.218 0 .427.086.582.24A.825.825 0 0 1 8 6.016a.828.828 0 0 1-1.122-.6.822.822 0 0 1 .807-.983Z",
    id: "infoBasic-8872637826736"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-81728971827",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-info-28389283208"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "infoBasic-1879292789723",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#infoBasic-8872637826736"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Icon-Shape-8872637826736",
    fill: "currentColor",
    xlinkHref: "#infoBasic-8872637826736"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBasic);
export default __webpack_public_path__ + "static/media/infoBasic.9c816db472bdf624a5266e0719bd18aa.svg";
export { ForwardRef as ReactComponent };